import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import { dismissErrors } from '../alertSlice';

const Alert = () => {
  const dispatch = useDispatch();
  const {
    errors,
    show,
  } = useSelector((state) => state.alert);

  let content = null;

  if (errors && errors.length > 0) {
    content = (
      <ul className="list-unstyled m-0">
        {errors.map((error, index) => <li key={index}>{error}</li>)}
      </ul>
    );
  }

  const handleClose = () => dispatch(dismissErrors());

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title>Warning</Modal.Title>
      </Modal.Header>
      <Modal.Body>{content}</Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <button type="button" className="btn btn-primary" onClick={handleClose}>
          ok
        </button>
      </Modal.Footer>
    </Modal>
  )
};

export default Alert;
